import React, { useEffect } from "react";
import Container from "../hoc/Container";

function SteamPagePlaceholder() {
  useEffect(() => {
    window.ym(93997310, "hit", "/steam", {
      params: {
        title: "Steam - Временно недоступно",
        referer: "https://trendy-eng-shop.ru/",
      },
    });
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <Container>
      <section className="content-block mb-2">
        <h1 className="head-1">Пополнение Steam</h1>
        
        <div className="flex flex-col items-center justify-center min-h-[400px] text-center">
          <div className="bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 rounded-lg p-8 max-w-2xl">
            <div className="mb-6">
              <svg className="mx-auto h-16 w-16 text-yellow-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
              </svg>
            </div>
            
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
              Страница временно недоступна
            </h2>
            
            <p className="text-gray-600 dark:text-gray-300 mb-6 text-lg">
              Мы обновляем функционал пополнения Steam. 
              Пожалуйста, воспользуйтесь нашим Telegram ботом для пополнения.
            </p>
            
            <div className="space-y-4">
              <a
                href="https://t.me/trendy_steam_bot?start=ref-001"
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors duration-200"
                onClick={() => window.ym(93997310, "reachGoal", "tgClickSteamPlaceholder")}
              >
                <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/>
                </svg>
                Перейти в Telegram бот
              </a>
              
              <div className="text-sm text-gray-500 dark:text-gray-400">
                <p>Или вернитесь на <a href="/" className="text-indigo-600 dark:text-indigo-400 hover:underline">главную страницу</a></p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Container>
  );
}

export default SteamPagePlaceholder;
